import config from 'react-global-configuration';
export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
import { AppOptions } from '../types';

export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED?.toLowerCase() === "true";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const MULTILINGUAL = false;

export const DEFAULT_LANGUAGE = 'nl';
export const SITE_NAME = 'nbbu';

export const HTTP_STATUS_PAGE_NOT_FOUND = 404;
export const HTTP_STATUS_PAGE_NO_ACCESS = 403;
export const HTTP_STATUS_SERVER_ERROR = 500;
export const HTTP_STATUS_SERVER_UNAVAILABLE = 503;

export let APP_OPTIONS = {
  parameters: {
    env: 'production',
    searchkitIndexAllContent: 'elasticsearch_index_drupal_content',
    searchkitIndexAllMembers: 'elasticsearch_index_drupal_members',
  }
};

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

export let API_URL = process.env.REACT_APP_API_URL || "//nbbu.devinc.eu";

// let API_URL = process.env.REACT_APP_API_URL || "//nbbu.devinc.eu";
export let SEARCHKIT_HOST_URL = process.env.REACT_APP_SEARCHKIT_HOST_URL || '/api-proxy/elasticsearch-proxy?_api_proxy_uri=';

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;
export const SCREEN_HUGE = 2000;

export const CONTENT_TYPE_ARTICLE = 'article';
export const CONTENT_TYPE_NEWS = 'news';
export const CONTENT_TYPE_COURSE = 'course';
export const CONTENT_TYPE_DOWNLOAD = 'download';
export const CONTENT_TYPE_OPINION = 'opinion';
export const CONTENT_TYPE_INTERVIEW = 'interview';

export const GROUPED_CONTENT_TYPES = {
  article: 'Artikel',
  news: 'Nieuws',
  download: 'Download',
  opinion: 'Opinie',
  interview: 'Interview',
};

export const BLOCK_ID_TRAINING_DETAIL_CTA = 1;
export const BLOCK_ID_GROUPED_CONTENT_DETAIL_CTA = 2;
export const BLOCK_ID_COURSE_INFORMATION = 3;

export const URL_PRIVACY_STATEMENT = '/nl/privacy-statement';

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': false,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
}, { freeze: false });

export function saveConstants(options: AppOptions) {
  APP_OPTIONS = options;

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
    SEARCHKIT_HOST_URL = 'http://localhost:3000/search';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': false,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
  });
}
